var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fundoPdf"},[_c('div',{staticClass:"escondeZoom",staticStyle:{"left":"0"}}),_c('div',{staticClass:"escondeZoom",staticStyle:{"right":"0"}}),_c('iframe',{ref:_vm.arquivo,attrs:{"title":"Arquivo","src":_vm.linkArquivo,"height":"600px","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }